import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex flex-col bg-gray-900 pt-10"
}
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "flex flex-row items-center h-full text-gray-700 text-5xl" }
const _hoisted_4 = { class: "flex w-full items-end p-8" }

import { computed, onBeforeMount, onBeforeUnmount, onMounted, PropType, ref, watch } from 'vue';
import { IGalleryImage } from '@/lib';
import { BaseIcon } from '@/lib/components/Icon';
import { ImageWrapper } from '@/lib/components/Image';
import ImagesGallery from './BaseImagesGallery.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Lightbox',
  props: {
  images: {
    type: Array as PropType<IGalleryImage[]>,
    default: () => []
  },
  startIndex: {
    type: Number,
    default: 0
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ["load", "close"],
  setup(__props, { emit }: { emit: ({
  (e: 'load', index: number): void;
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const selectedIndex = ref(0);

const image = computed<string>(() => {
  const image = props.images[selectedIndex.value];
  if (image && image.imageUri && image.imageUri.length) {
    return image.imageUri;
  }
  if (image && image.image && image.image.length) {
    return image.image;
  }
  return '';
});


watch(() => props.startIndex, () => {
  selectedIndex.value = props.startIndex >= 0 && props.startIndex <= props.images.length ? props.startIndex : 0;
});
watch(selectedIndex, () => {
  emit('load', selectedIndex.value);
});

onBeforeMount(() => {
  selectedIndex.value = props.startIndex >= 0 && props.startIndex <= props.images.length ? props.startIndex : 0;
});
onMounted(() => {
  if (props.images[selectedIndex.value]) {
    emit('load', selectedIndex.value);
  }
  window.addEventListener('keydown', onKeyDown);
});
onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeyDown);
});
const onKeyDown = (ev: KeyboardEvent) => {
  if (ev.key === 'ArrowLeft') {
    previousImage();
  }
  if (ev.key === 'ArrowRight') {
    nextImage();
  }
  if (ev.key === 'Escape') {
    close();
  }
};
const nextImage = () => {
  selectedIndex.value = selectedIndex.value + 1 < props.images.length ? selectedIndex.value + 1 : 0;
};
const previousImage = () => {
  selectedIndex.value = selectedIndex.value > 0 ? selectedIndex.value - 1 : props.images.length - 1;
};
const close = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (__props.images && __props.images.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "absolute focus:outline-none top-0 left-0 text-white bg-gray-800 p-3 rounded-r-full text-sm text-center w-14 h-12 hover:bg-gray-600",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
          }, [
            _createVNode(_unref(BaseIcon), {
              name: "close",
              class: "stroke-1.5"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "hover:text-white h-12 focus:outline-none",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (previousImage()))
          }, [
            _createVNode(_unref(BaseIcon), {
              class: "ml-12 mr-16",
              name: "left-arrow"
            })
          ]),
          _createVNode(_unref(ImageWrapper), {
            class: "h-auto w-auto",
            "image-url": _unref(image),
            loading: __props.loading
          }, _createSlots({
            "bottom-right": _withCtx(() => [
              _createTextVNode(_toDisplayString(selectedIndex.value + 1) + " / " + _toDisplayString(__props.images.length), 1)
            ]),
            _: 2
          }, [
            (__props.images[selectedIndex.value].date)
              ? {
                  name: "top-left",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.images[selectedIndex.value].date), 1)
                  ]),
                  key: "0"
                }
              : undefined,
            (__props.images[selectedIndex.value].description)
              ? {
                  name: "bottom-left",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.images[selectedIndex.value].description), 1)
                  ]),
                  key: "1"
                }
              : undefined
          ]), 1032, ["image-url", "loading"]),
          _createElementVNode("button", {
            type: "button",
            class: "hover:text-white h-12 focus:outline-none",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (nextImage()))
          }, [
            _createVNode(_unref(BaseIcon), {
              class: "hover:text-white mr-12 ml-16",
              name: "right-arrow"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ImagesGallery, {
            modelValue: selectedIndex.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedIndex).value = $event)),
            class: "justify-center",
            images: __props.images
          }, null, 8, ["modelValue", "images"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})